// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.premium-plans-popup {
    background-color: rgba(0, 0, 0, 0.3);
    height: 100%;
    width: 100%;
    z-index: 11;
    top: 0;
    left: 0;
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;
}

.premium-pop-up {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    background-color: #FFFFFF;
}

.premium-pop-up::-webkit-scrollbar {
    width: 4px;
    height: 0;
}

.premium-pop-up::-webkit-scrollbar-track {
    background: #eeeeee;
}

.premium-pop-up::-webkit-scrollbar-thumb {
    background: #757575;
}


.premium-pop-up-header {
    display: flex;
    color: #212121;
    font-size: 16px;
    align-items: center;
    margin: 10px 20px 10px 5%;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    justify-content: space-between;
}

.premium-pop-up-header span {
    font-size: 18px;
    font-weight: bold;
}

.premium-pop-up-header p {
    margin: 5px 0 20px 0;
    color: #4D4D4D;
}

.premium-pop-up-body {
    display: flex;
    margin: 20px 40px 20px 5%;
    justify-content: space-between;
}

.yearly-monthly {
    padding: 5px;
    display: flex;
    margin: 25px auto;
    width: fit-content;
    background: #DDEBF8;
    border-radius: 50px;
}

.yearly-monthly span {
    border-radius: 50px;
    padding: 5px 20px;
    cursor: pointer;
}

.save-upto {
    color: #1976D2;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/app/dashboard/css/premium-plans-popup.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,YAAY;IACZ,WAAW;IACX,WAAW;IACX,MAAM;IACN,OAAO;IACP,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,aAAa;IACb,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":[".premium-plans-popup {\n    background-color: rgba(0, 0, 0, 0.3);\n    height: 100%;\n    width: 100%;\n    z-index: 11;\n    top: 0;\n    left: 0;\n    position: fixed;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 0;\n    padding: 0;\n}\n\n.premium-pop-up {\n    width: 100%;\n    height: 100%;\n    overflow-y: auto;\n    background-color: #FFFFFF;\n}\n\n.premium-pop-up::-webkit-scrollbar {\n    width: 4px;\n    height: 0;\n}\n\n.premium-pop-up::-webkit-scrollbar-track {\n    background: #eeeeee;\n}\n\n.premium-pop-up::-webkit-scrollbar-thumb {\n    background: #757575;\n}\n\n\n.premium-pop-up-header {\n    display: flex;\n    color: #212121;\n    font-size: 16px;\n    align-items: center;\n    margin: 10px 20px 10px 5%;\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n    justify-content: space-between;\n}\n\n.premium-pop-up-header span {\n    font-size: 18px;\n    font-weight: bold;\n}\n\n.premium-pop-up-header p {\n    margin: 5px 0 20px 0;\n    color: #4D4D4D;\n}\n\n.premium-pop-up-body {\n    display: flex;\n    margin: 20px 40px 20px 5%;\n    justify-content: space-between;\n}\n\n.yearly-monthly {\n    padding: 5px;\n    display: flex;\n    margin: 25px auto;\n    width: fit-content;\n    background: #DDEBF8;\n    border-radius: 50px;\n}\n\n.yearly-monthly span {\n    border-radius: 50px;\n    padding: 5px 20px;\n    cursor: pointer;\n}\n\n.save-upto {\n    color: #1976D2;\n    font-size: 16px;\n    font-weight: bold;\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
